import {Base} from "@/api/Base"

export class InsuranceCompanyEdit extends Base {
    path = "insuranceCompany/edit"
}